import { useMemo } from 'react';
import { detectAnomalies } from '../utils/anomalyDetection';

export function useAnomalyDetection(allTxns, selMonth, selYear, incomeList) {
  return useMemo(
    () => detectAnomalies(allTxns, selMonth, selYear, incomeList),
    [allTxns, selMonth, selYear, incomeList]
  );
}
